import React from 'react';
import { Button, Form, Grid, Header, Image, Segment } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import logo from 'resources/logo.png';
import * as styles from './styles';
import { withRouter } from 'react-router-dom';
import Auth from 'stores/Auth';
import MsgStore from 'stores/MsgStore';
import MessageBox from 'components/MessageBox';
import * as yup from 'yup';

@withRouter
@inject(root => ({
	auth: root.auth
}))
@observer
export default class PasswordReset extends React.Component {
	propTypes: {
		auth?: Auth
	};

	msgStore = new MsgStore();

	resetPassword = async () => {
		this.msgStore.clear();
		try {
			await yup
				.string()
				.email()
				.required()
				.label('E-mail')
				.validate(this.email);
			await Auth.passwordReset(this.email, 'SAM - Password Reset');
			this.msgStore.setInfo('You should receive an email with instructions shortly.');
		} catch (err) {
			this.msgStore.setError(err);
		}
	};

	render() {
		return (
			<div className={styles.passwordResetPage}>
				<Grid textAlign="center" style={{ height: '100%' }} verticalAlign="middle">
					<Grid.Column style={{ maxWidth: 450 }}>
						<Header as="h2" color="blue" textAlign="center">
							<Image src={logo} className={styles.logo} />
							<div>Password reset</div>
						</Header>
						<Form size="large">
							{!this.msgStore.info && (
								<Segment>
									<Form.Input
										fluid
										icon="envelope outline"
										iconPosition="left"
										placeholder="E-mail address"
										value={this.email}
										onChange={e => {
											this.email = e.target.value;
										}}
									/>

									<Button
										primary
										fluid
										size="large"
										onClick={() => {
											this.resetPassword();
										}}
									>
										Submit
									</Button>
								</Segment>
							)}
							<MessageBox msgStore={this.msgStore} />
						</Form>
					</Grid.Column>
				</Grid>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/public/PasswordReset/index.js